import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/store';
import { logout } from '../../app/slice/authSlice';

interface DashboardState {
  showNav: boolean;
  isCollapsed: boolean;
}

const initialState: DashboardState = {
  showNav: true,
  isCollapsed: false,
};

export const dashboardSlice = createSlice({
  name: 'dashboard', 
  initialState,
  reducers: {
    toggleSideNav: (state, action: PayloadAction<boolean>) => {
      state.showNav = action.payload;
    },
    toggleCollapse: (state) => {
      state.isCollapsed = !state.isCollapsed;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => ({ ...initialState }));
  },
});

export const { toggleSideNav, toggleCollapse } = dashboardSlice.actions;

export const selectShowNav = (state: RootState) => state.dashboard.showNav;

export default dashboardSlice.reducer;
